import React from 'react';
import { motion } from 'framer-motion';
import { useAppContext } from '../context/AppContext';

export default function LanguageToggle() {
  const { language, toggleLanguage } = useAppContext();

  return (
    <motion.button
      className="lang-toggle"
      onClick={toggleLanguage}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      aria-label={`Switch to ${language === 'tr' ? 'English' : 'Turkish'}`}
    >
      {language === 'tr' ? 'EN' : 'TR'}
    </motion.button>
  );
}
